// extracted by mini-css-extract-plugin
module.exports = {"MainDetails":"MainDetails_MainDetails__Q5wCM"};